module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'is-unm': _vm.$store.getters.isUnmMain
    },
    attrs: {
      "id": "search-by-keyword"
    }
  }, [_c('div', {
    attrs: {
      "id": "searchbar"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchKey),
      expression: "searchKey"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Search"
    },
    domProps: {
      "value": (_vm.searchKey)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchKey = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fas fa-search"
  })]), _vm._v(" "), _c('major-list', {
    attrs: {
      "majors": _vm.filteredMajors
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d65865b","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/KeywordSearch.vue
// module id = 1128
// module chunks = 1